import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useGetDeviceOverallInfo } from "../../api/hooks/reports";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";

export default function DevicesOverviewTable() {
  const { data } = useGetDeviceOverallInfo();
  return (
    <Container maxWidth='md'>
      <Paper variant="outlined">
        <List dense sx={{
          padding: 1,
          backgroundColor: 'white'
        }}>
          <ListItem key="0">
            <ListItemText id={'labelId'} primaryTypographyProps={{ variant: 'body1' }}
              primary="تعداد دستگاه‌های ثبت شده" />
            <ListItemSecondaryAction>
              <Typography variant="h6">
                {data?.deviceNum?.toLocaleString('fa-IR')}
              </Typography>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem key="1">
            <ListItemText id={'labelId'} primaryTypographyProps={{ variant: 'body1' }}
              primary="تعداد دستگاه‌های فعال‌شده" />
            <ListItemSecondaryAction>
              <Typography variant="h6">
                {data?.activatedDeviceNum?.toLocaleString('fa-IR')}
              </Typography>
            </ListItemSecondaryAction>
          </ListItem>

        </List>
      </Paper>
    </Container>
  )
}


